import { discriminatedUnion, z } from 'zod';
import { addDays } from '@tools/dates';

const nederlandsAdresSchema = z.object({
  isNederlands: z.literal(true),
  land: z.string({ required_error: 'Land is verplicht' }),
  postcode: z
    .string({ required_error: 'Postcode is verplicht' })
    .min(6, 'Postcode is verplicht')
    .max(7, 'Postcode mag maximaal 7 karakters bevatten'),
  huisnummer: z.number({ required_error: 'Huisnummer is verplicht' }).max(99999).min(1),
  huisnummertoevoeging: z
    .string()
    .max(10, 'Huisnummertoevoeging mag niet meer dan 10 karakters bevatten')
    .nullable()
    .optional(),
  straat: z
    .string({ required_error: 'Straat is verplicht' })
    .max(35, 'Straat mag niet meer dan 35 karakters bevatten'),
  plaats: z
    .string({ required_error: 'Plaats is verplicht' })
    .max(25, 'Plaats mag niet meer dan 25 karakters bevatten'),
});

const buitenlandsAdresSchema = z.object({
  isNederlands: z.literal(false),
  land: z.string({ required_error: 'Land is verplicht' }),
  postcode: z
    .string()
    .max(10, { message: 'Postcode mag maximaal 10 karakters bevatten' })
    .optional(),
  adres: z
    .string({ required_error: 'Adres is verplicht' })
    .min(1, 'Adres mag niet leeg zijn')
    .max(200, 'Adres mag maximaal 200 karakters bevatten'),
  plaats: z
    .string({ required_error: 'Plaats is verplicht' })
    .min(1, 'Plaats mag niet leeg zijn')
    .max(100, 'Plaats mag maximaal 100 karakters bevatten'),
});

export const uboSchema = z.object({
  achternaam: z
    .string({ required_error: 'Achternaam is verplicht' })
    .min(1, { message: 'Achternaam mag niet leeg zijn' })
    .max(50, { message: 'Achternaam mag maximaal 50 karakters bevatten' }),
  adres: discriminatedUnion('isNederlands', [nederlandsAdresSchema, buitenlandsAdresSchema]),
  voorletters: z
    .string({ required_error: 'Voorletters zijn verplicht' })
    .min(1, { message: 'Voorletters mogen niet leeg zijn' })
    .max(10, { message: 'Voorletters mogen maximaal 10 karakters bevatten' }),
  geboortedatum: z
    .date({ required_error: 'Vul een geldige geboortedatum in' })
    .max(addDays(new Date(), -1), { message: 'Geboortedatum moet in het verleden liggen' })
    .min(new Date(1900, 1, 1), {
      message: 'Geboortedatum mag niet te ver in het verleden liggen',
    }),
});
